import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{
      background: '#1a1a2e',
      padding: '40px 64px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
        marginBottom: 24, flexWrap: 'wrap', gap: 24,
      }}>
        <div>
          <p style={{ color: '#fff', fontSize: 17, fontWeight: 700, marginBottom: 8, letterSpacing: '-0.01em' }}>
            サイトモックアップ ジェネレーター
          </p>
          <p style={{ color: '#94a3b8', fontSize: 13, lineHeight: 1.7 }}>
            参考URLを入力するだけで、5種類のWebデザイン案を自動生成します
          </p>
        </div>
        <div style={{ display: 'flex', gap: 28, alignItems: 'center', flexShrink: 0 }}>
          <a
            href="https://takamasado.com/contact/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#94a3b8', fontSize: 13, textDecoration: 'none', transition: 'color 0.15s' }}
            onMouseEnter={e => (e.currentTarget.style.color = '#fff')}
            onMouseLeave={e => (e.currentTarget.style.color = '#94a3b8')}
          >
            お問い合わせ
          </a>
          <a
            href="https://takamasado.com/privacypolicy/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#94a3b8', fontSize: 13, textDecoration: 'none', transition: 'color 0.15s' }}
            onMouseEnter={e => (e.currentTarget.style.color = '#fff')}
            onMouseLeave={e => (e.currentTarget.style.color = '#94a3b8')}
          >
            プライバシーポリシー
          </a>
          <Link
            to="/terms"
            style={{ color: '#94a3b8', fontSize: 13, textDecoration: 'none', transition: 'color 0.15s' }}
            onMouseEnter={e => (e.currentTarget.style.color = '#fff')}
            onMouseLeave={e => (e.currentTarget.style.color = '#94a3b8')}
          >
            利用規約
          </Link>
        </div>
      </div>
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 20 }}>
        <p style={{ color: '#475569', fontSize: 12, textAlign: 'center' }}>
          © 2025 髙正堂 TAKAMASADO Inc. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
